'use strict'

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { router } from './router'
import $ from 'jquery'
import Bowser from 'bowser'
import App from './App.vue'
import NoApp from './NoApp.vue'
import { SocketHandler, MicroService, connection } from '@/assets/javascript/mixins/Mixins'
import { Store } from '@/assets/javascript/store'
import clientConfig from '@/client_config.json'
import { deleteCookie, getCookie, setDomainCookie } from '@libs/cookie-handling'
import axios from 'axios'
import { preloadImages } from '@/assets/javascript/utilities'

import '@/assets/javascript/FontAwesomeLib'
import {
    defaultLocale,
    languages,
    localeOverview,
    changeFavIcon
} from '@/assets/internationalization/internationalizations.js'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { setPrograms } from './assets/javascript/storeProcedures'

// // Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// // Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

/**
 * Vue Translation library
 */
var i18n = null

/**
 * General Application Settings
 */
const init = async () => {
    /**
   * Adding jQuery to Global Scope
   */
    window.$ = window.jQuery = $

    /*
    global syncing variable
    for syncing modal window
    */
    window.syncing = false

    /*
    global variable for
    
    */

    window.programs = {
        1: {},
        2: {},
        3: {},
        4: {},
        5: {},
        6: {},
        7: {},
        8: {},
        9: {},
        10: {}
    }

    /**
     * Translations
     */
    const messages = Object.assign(languages)

    Vue.use(VueI18n)

    i18n = new VueI18n({
        locale: defaultLocale,
        fallbackLocale: defaultLocale,
        messages
    })

    i18n.localeOverview = localeOverview

    /**
     * Loading whitelabel remotely, wait until it is done (sideload into translations for ease of use)
     */

    const baseURL = connection.getConnectionString('microservice')
    const axiosInstance = axios.create({
        timeout: 10000,
        baseURL
    })

    const whitelabel = await axiosInstance.request({
        method: 'GET',
        url: `/api/whitelabels?whitelabel=${window.location.hostname}`
    })
        .then((response) => {
            response.data.logoImg = baseURL + response.data.logoImg
            response.data.favIcon = baseURL + response.data.favIcon
            return response.data
        }).catch(console.error)

    if (whitelabel) {
        await preloadImages([whitelabel.logoImg, whitelabel.favIcon], 7000).catch(error => {
            console.error('Error fetching whitelabeling', error)
            whitelabel.logoImg = ''
            whitelabel.favIcon = ''
        })

        i18n.whitelabel = whitelabel

        setDomainCookie(btoa(whitelabel.label), 'wl', 999999)

        i18n.whitelabel.favIcon
            ? changeFavIcon(i18n.whitelabel.favIcon)
            : console.warn('No FavIcon found for', i18n.whitelabel.label)

        const language = getCookie('lang')

        if (!language) setDomainCookie(btoa(defaultLocale), 'lang', 999999)
    } else {
        document.body.prepend('MSERR:521')
        return console.error('Error getting whitelabeling.')
    }

    /**
     * Turn on dev tools for CIMS 2 (production build)
     */
    const devTools = window.location.hostname === 'cims2.crysberg.com' || window.location.hostname === 'localhost'
    Vue.config.devtools = devTools
    if (devTools) {
        console.warn('Vue Devtools enabled for this address.')
    }

    /**
     * General Information
     */
    Vue.config.productionTip = false
    if (process.env.NODE_ENV === 'development') {
        console.warn('Application in development mode.')
    }

    const canStart = () => !['Trident', 'EdgeHTML'].includes(Bowser.parse(window.navigator.userAgent).engine.name)
    canStart() ? startApplication() : denyApplication()
}

const startApplication = () => {
    // Create and mount the root instance.
    var app = new Vue({
        el: '#app',
        router: router,
        i18n,
        components: {
            App
        },
        mixins: [SocketHandler, MicroService],
        data:
        {
            store: null,
            // PageMessage
            PageMessage: {},
            // Configuration
            SelectedDevice: {},
            // Socket
            SocketConnected: false,
            SocketMessage: {},
            LoggedIn: false,
            // Message dialog
            MessageShow: false,
            MessageHeader: '',
            MessageBody: '',
            MessageHaveOk: false,
            MessageHaveCancel: false,
        },
        computed: {
            computedSelectedLocale() {
                return this.store ? this.store.getData('settings.internationalization.selectedLocale') : ''
            }
        },
        watch: {
            computedSelectedLocale(locale) {
                if (locale) {
                    i18n.locale = locale.locale ? locale.locale : locale // can be either string or object
                } else {
                    console.warn('locale', locale, 'not valid')
                }
            },
            '$route'(to) {

                if (to.path === '/devicelist') {
                    this.store.resetStoreData()
                }


                this.SocketMessageSend({ category: 'route', data: to.path })

                if (to.path === '/') {
                    this.Logout()
                }
            },
            SocketMessage(Message) {
                if (
                    Message.data &&
                    Message.data.category &&
                    Message.data.category === 'data' &&
                    Message.data.command &&
                    Message.data.command === 'get' &&
                    Message.data.data.type &&
                    Message.data.data.type === 'dataset' &&
                    Message.data.data.record && Message.data.data.record[0].login) {
                    this.LoggedIn = true
                } else if (Message.data &&
                    Message.data.category &&
                    Message.data.category === 'server' &&
                    Message.data.command &&
                    Message.data.command === 'info' &&
                    Message.data.data.code &&
                    Message.data.data.code && Message.data.data.code === 'E10') {
                    this.LoggedIn = false
                }
            },
            LoggedIn() {
                if (this.LoggedIn === false) {
                    this.$router.push('/').catch(() => { })
                    this.store.resetStoreData()
                    this.store.resetUser()
                }
            },
            PageMessage(msg) {
                if (this.PageMessage.target === 'Disconnect')
                    this.Logout()

                if (this.PageMessage.target === 'SetDevice')
                    this.SelectedDevice = this.PageMessage.data

                if (this.PageMessage.target === 'updateI18n') {
                    i18n.mergeLocaleMessage(i18n.locale, msg.data)
                    if (clientConfig.debug) console.log(i18n.messages['en-US'])
                    if (clientConfig.debug) console.log(this.$i18n.messages['en-US'])
                }
            }
        },
        mounted() {
            this.$root.$on('extendtime', () =>
                this.SocketMessageSend({ category: 'server', command: 'extendtime' }))

            if (clientConfig.debug) console.error('DEBUG ON')
            var txt = {
                category: 'Browser',
                iplocal: [],
                data: {
                    'CodeName': navigator.appCodeName,
                    'Name': navigator.appName,
                    'Version': navigator.appVersion,
                    'Cookies Enabled': navigator.cookieEnabled,
                    'Language': navigator.language,
                    'Online': navigator.onLine,
                    'Platform': navigator.platform,
                    'User-agent header': navigator.userAgent,
                    'Geographical': navigator.geolocation,
                }
            }

            this.connection.socket.on('connect', () => {
                var browserInfoSent = false
                this.SocketConnected = true

                if (clientConfig.debug) console.log('Socket id: ', this.connection.socket.id)

                txt.iplocal = this.ip_local((iplocal) => {
                    browserInfoSent = true
                    txt.iplocal = iplocal
                    this.SocketMessageSend(txt)
                })

                setTimeout(() => {
                    if (!browserInfoSent) this.SocketMessageSend(txt)
                }, 1000)

                window.localStorage.setItem('session', JSON.stringify({
                    sessionId: this.connection.socket.id,
                    timestamp: new Date() / 1000
                }))
            })

            this.connection.socket.on('disconnect', info => { // Forced by server to disconnect
                console.warn('Disconnect:', info)
                // Propagate
                this.SocketConnected = false
                if (info === 'io server disconnect') {
                    this.sendMicroServiceRequest({
                        method: 'POST',
                        url: 'api/authenticated/function/udp_send',
                        data: {
                            host: '10.0.10.4',
                            port: 514,
                            message: 'Client ' + JSON.stringify({
                                from: 'NGWI Client',
                                event: 'io server disconnect',
                                userAgent: navigator.userAgent,
                                localTime: new Date()
                            })
                        }
                    })
                        .then(() => location.reload())
                        .catch(() => location.reload())

                    setTimeout(location.reload, 5000)
                }
            })

            this.connection.socket.on('error', function (Error) {
                console.error('%cERR Socket got error: ' + Error, 'colour: red')
            })

            this.connection.socket.on('connect_error', function (Error) {
                console.error('%cERR Socket connect error: ' + Error, 'colour: red')
            })

            this.connection.socket.on('Time', time => this.SocketMessage = { category: 'Time', data: time })

            this.connection.socket.on('message', message => {
                if (clientConfig.debug) {
                    var str = JSON.stringify(message)
                    if (str.length > 130) str = str.substring(0, 130) + '...'
                    console.log('%c <-- socket message: ', 'color: "magenta"', str)
                }

                this.SocketMessage = {
                    category: 'Message',
                    data: message
                }
            })
        },
        created() {
            this.store = new Store()

            const language = getCookie('lang')

            if (language) this.store.setData('settings.internationalization.selectedLocale', atob(language))

            if (process.env.VUE_APP_HASH)
                this.store.setData('application.versions.client', process.env.VUE_APP_HASH)

            this.SocketMessageSend({ category: 'route', data: this.$route.path })
        },
        methods: {
            SetPageMessage(Message) {
                this.$set(this, 'PageMessage', Message)
            },
            Logout() {
                window.localStorage.removeItem('session')
                if (this.LoggedIn) {
                    console.warn('Logging Out')
                    deleteCookie('auth')
                    this.SocketMessageSend({ category: 'client', command: 'logout' })
                    this.SocketMessageSend({ category: 'client', command: 'disconnect' })
                    this.LoggedIn = false
                    window.location = this.connection.getConnectionString('sso')
                }
            },
            ReleaseDevice() {
                setTimeout(() => {
                    if (this.SelectedDevice !== undefined && Object.keys(this.SelectedDevice).length !== 0) {
                        console.warn('Releasing Device', this.SelectedDevice.ctrlid)
                        this.SocketMessageSend({ category: 'server', command: 'deselect', data: { type: 'device', item: this.SelectedDevice.ctrlid } })
                    }
                }, 0)
            },
            ip_local(callback) {
                var ip = false
                window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection || false

                if (window.RTCPeerConnection) {
                    ip = []
                    var pc = new RTCPeerConnection({ iceServers: [] })
                    var noop = function () { }
                    pc.createDataChannel('')
                    pc.createOffer(pc.setLocalDescription.bind(pc), noop)

                    pc.onicecandidate = function (event) {
                        if (event && event.candidate && event.candidate.candidate) {
                            var s = event.candidate.candidate.split('\n')
                            ip.push(s[0].split(' ')[4])
                            callback(ip)
                        }
                    }
                }
                return ip
            }
        },
        template: `
      <App
        :store = "store"
        :page-message="PageMessage"
        :socket-message="SocketMessage"
        :selected-device="SelectedDevice"
        :logged-in="LoggedIn"
        @SetPageMessage = "SetPageMessage" />
    `
    })

    if (process.env.NODE_ENV === 'development') { // e2e tests
        window.app = app
    }
}

const denyApplication = () => {
    new Vue({
        el: '#app',
        i18n,
        components: {
            NoApp
        },
        template: '<NoApp />'
    })
}

init()

